import axios from "axios";
import authstore from '@/store/modules/auth';
import appstore from '@/store/modules/app';

export const instance = axios.create({

});
instance.interceptors.request.use( async config => { 
    //let token = store.getters["authmodule/getToken"]
    if(authstore.state.token){
        config.headers.Authorization = `Bearer ${authstore.state.token}`;
    }
    config.headers['Accept-Language'] = appstore.state.language;
    return config; 
}, error => Promise.reject(error) );